export const energyFormParametersGeneration = ({
  contactPreferences = {},
  billingData = {},
  propaneData = {},
  electricityMeterData = {},
  gasMeterData = {},
  contractData,
  characteristicsData,
  energyConsumptionData = {},
  mainAddressData = {},
  // invoicingAddressData,
  contractId,
  contactId,
  addressId,
  billingAddressId,
  action = 'save',
  type,
}) => {
  const options = new URLSearchParams()
  const { electricityMeter = {}, gasMeter = {} } = mainAddressData

  options.append('action', action)
  options.append('type', type || '')
  options.append('id', contractId || '')
  options.append('contact_id', contactId || '')
  options.append('address_id', addressId || '')
  options.append('client_type', contactPreferences.clientType || '')
  options.append('prestation_type', characteristicsData.prestationType || '')
  options.append('energy_type', characteristicsData.energyType || '')
  options.append('germany_heating_meter_contract', characteristicsData.germanyHeatingMeterContract ? '1' : '0')
  options.append('cdf_delayed', characteristicsData.cdfDelayed ?? '')
  if (characteristicsData.disclaimerCommitmentPro !== null) {
    options.append('disclaimer_commitment_pro', characteristicsData.disclaimerCommitmentPro || '')
  }

  /* options.append('household', mainAddressData.household || '')
  options.append('occupancy', mainAddressData.occupancy || '')
  options.append('moving_start_date', mainAddressData.movingStartDate || '')

  if (country === 'it') {
    options.append('city_id', mainAddressData.cityId || '')
  } */

  options.append('offer_id', contractData.offerId ? parseInt(contractData.offerId) : '')
  options.append('organisation_id', contractData.providerId ? parseInt(contractData.providerId) : '')

  if (contractData.commitmentEndDate !== null) {
    options.append('commitment_end_date', contractData.commitmentEndDate || '')
  }

  options.append('is_debordement', contractData.isDebordement ?? '0')
  options.append('payment_mode_real', billingData.realPayment ?? '')
  options.append('mes_emergency', contractData.mesEmergency ?? '')
  if (contractData.providerExternalId) {
    options.append('provider_external_id', contractData.providerExternalId)
  }
  if (electricityMeterData.providerExternalId) {
    options.append('provider_external_id_elec', electricityMeterData.providerExternalId)
  }
  if (gasMeterData.providerExternalId) {
    options.append('provider_external_id_gas', gasMeterData.providerExternalId)
  }
  if (energyConsumptionData.monthlyAmount && parseInt(energyConsumptionData.monthlyAmount) > 0) {
    options.append('monthly_amount', energyConsumptionData.monthlyAmount)
  }
  /*
  if (invoicingAddressData.showCheckbox === true) {
    options.append('facturation_address_different', '1')
    options.append('fact_street_name', invoicingAddressData.address || '')
    options.append('fact_street_number', invoicingAddressData.streetNumber || '')
    options.append('fact_floor', invoicingAddressData.floor || '')
    options.append('fact_appartment_number', invoicingAddressData.appartmentNumber || '')
    options.append('fact_complement_address', invoicingAddressData.additionalInformation || '')
    options.append('fact_city', invoicingAddressData.city)
    options.append('fact_zipcode', invoicingAddressData.zipcode)
    options.append('fact_country', invoicingAddressData.country)
  }
*/
  if (characteristicsData.energyType === 'dual' || characteristicsData.energyType === 'elec') {
    if (energyConsumptionData.monthlyAmountElec && parseInt(energyConsumptionData.monthlyAmountElec) > 0) {
      options.append('monthly_amount_elec', energyConsumptionData.monthlyAmountElec)
    }
    options.append('meter_id_elec', electricityMeter.pdlNo || '')
    if (electricityMeterData.effectiveDate) {
      options.append('effective_date_elec', electricityMeterData.effectiveDate)
    }
    if (electricityMeterData.bypassRetractation === true || electricityMeterData.bypassRetractation === 1) {
      options.append('bypass_retractation_elec', '1')
    }
    if (electricityMeterData.enedisAuth === true) {
      options.append('meter_consent_acceptation_elec', electricityMeterData.consentDate)
    }
    if (electricityMeterData.meterType) {
      options.append('meter_type_elec', electricityMeterData.meterType)
    }
    if (electricityMeterData.meterOpening) {
      options.append('meter_opening_elec', electricityMeterData.meterOpening)
    }
    if (electricityMeterData.energySupplier) {
      options.append('supplier_id_elec', electricityMeterData.energySupplier || '')
    }
    if (electricityMeterData.smartMeter) {
      options.append('is_smart_meter_elec', parseInt(electricityMeterData.smartMeter) === 1 ? '1' : '0')
    }
    if (electricityMeterData.billAmount) {
      options.append('last_bill_amount_elec', electricityMeterData.billAmount || '')
    }
    if (electricityMeterData.meterPower) {
      options.append('meter_power_elec', electricityMeterData.meterPower)
    }
    if (electricityMeterData.originalMeterPower) {
      options.append('original_meter_power_elec', electricityMeterData.originalMeterPower)
    }
    if (electricityMeterData.meterOption) {
      options.append('meter_option_elec', electricityMeterData.meterOption)
    }
    if (electricityMeterData.originalMeterOption) {
      options.append('original_meter_option_elec', electricityMeterData.originalMeterOption)
    }
    options.append('main_index_elec', electricityMeterData.indexBaseHP || 0)
    options.append('secondary_index_elec', electricityMeterData.indexHC || 0)
    if (electricityMeterData.readingDate) {
      options.append('reading_date_elec', electricityMeterData.readingDate)
    }
    if (electricityMeterData.meterState) {
      options.append('meter_state_elec', electricityMeterData.meterState)
    }
    options.append('car_elec_base', energyConsumptionData.carBase || 0)
    options.append('consumption_base', energyConsumptionData.consumptionBase || 0)
    options.append('car_elec_hp', energyConsumptionData.carHp || 0)
    options.append('consumption_biorariaF1', energyConsumptionData.consumptionBiorariaF1 || 0)
    options.append('car_elec_hc', energyConsumptionData.carHc || 0)
    options.append('consumption_biorariaF2', energyConsumptionData.consumptionBiorariaF2 || 0)
    options.append('consumption_biorariaF3', energyConsumptionData.consumptionBiorariaF3 || 0)

    if (electricityMeterData.energyOrigin) {
      options.append('energy_origin_elec', electricityMeterData.energyOrigin)
    }

    options.append('car_elec_base_original', energyConsumptionData.carBaseOriginal || 0)
    options.append('car_elec_hp_original', energyConsumptionData.carHpOriginal || 0)
    options.append('car_elec_hc_original', energyConsumptionData.carHcOriginal || 0)
    options.append(
      'enedis_original_car',
      electricityMeter?.pdlEligibilityData?.elec?.consumption?.yearlyExtrapolation || 0,
    )
  }

  if (characteristicsData.energyType === 'dual' || characteristicsData.energyType === 'gas') {
    if (energyConsumptionData.monthlyAmountGas && parseInt(energyConsumptionData.monthlyAmountGas) > 0) {
      options.append('monthly_amount_gas', energyConsumptionData.monthlyAmountGas)
    }
    options.append('meter_id_gas', gasMeter.pceNo || '')
    options.append('main_index_gas', gasMeterData.index || 0)

    if (gasMeterData.meterAuth === true) {
      options.append('meter_consent_acceptation_gas', gasMeterData.consentDate)
    }

    if (gasMeterData.effectiveDate) {
      options.append('effective_date_gas', gasMeterData.effectiveDate)
    }
    options.append('car_gas', energyConsumptionData.carGas || 0)
    options.append('car_gas_original', energyConsumptionData.carGasOriginal || 0)
    if (gasMeterData.energyOrigin) {
      options.append('energy_origin_gas', gasMeterData.energyOrigin)
    }

    if (gasMeterData.readingDate) {
      options.append('reading_date_gas', gasMeterData.readingDate)
    }
    if (gasMeterData.bypassRetractation === true || gasMeterData.bypassRetractation === 1) {
      options.append('bypass_retractation_gas', '1')
    }
    if (gasMeterData.meterType) {
      options.append('meter_type_gas', gasMeterData.meterType)
    }
    if (gasMeterData.energySupplier) {
      options.append('supplier_id_gas', gasMeterData.energySupplier || '')
    }
    if (gasMeterData.smartMeter) {
      options.append('is_smart_meter_gas', parseInt(gasMeterData.smartMeter) === 1 ? '1' : '0')
    }
    if (gasMeterData.billAmount) {
      options.append('last_bill_amount_gas', gasMeterData.billAmount || '')
    }
  }

  if (energyConsumptionData.modificationReason) {
    options.append('car_modification_reason', energyConsumptionData.modificationReason)
  }

  if (billingData.providersBlacklist) {
    options.append('blacklist_providers', JSON.stringify(billingData.providersBlacklist))
  }

  if (billingData.frequency) {
    options.append('invoice_frequency', billingData.frequency || '-1')
  }

  if (billingData.paymentMode) {
    options.append('payment_mode', billingData.paymentMode || '-1')
  }

  if (billingData.paymentModeAlt) {
    options.append('payment_mode_alt', billingData.paymentModeAlt || '-1')
  }

  options.append('invoice_sending_mode', billingData.sendingMode || '')
  options.append('payment_date', billingData.paymentDate || '')
  options.append('iban', billingData.iban || '')
  options.append('promotional_code', billingData.promoCode || '')

  if (billingData.businessCard === true) {
    options.append('business_card', '1')
  }

  if (billingData.bic?.length > 0) {
    options.append('bic', billingData.bic)
  }
  if (billingAddressId) {
    options.append('billing_address_id', billingAddressId)
  }

  if (billingData.differentAccountHolder === true) {
    options.append('owner_name_different', 1)
    options.append('owner_lastname', billingData.accountHolderLastname || '')
    options.append('owner_firstname', billingData.accountHolderFirstname || '')
  }
  if (characteristicsData.energyType === 'propane') {
    if (propaneData?.garden === true) {
      options.append('garden_propane', '1')
    } else if (propaneData?.garden === false) {
      options.append('garden_propane', '0')
    }
    options.append('quote_reason_propane', propaneData?.quoteReason || '')
    options.append('explanations_propane', propaneData?.explanations || '')
    options.append('supplier_id_propane', propaneData?.energySupplier || '')
    options.append('contact_time_propane', propaneData?.contactTime || '')
    options.append('car_propane', propaneData?.car || '')
    options.append('presence_propane', propaneData?.presence || '')
    options.append('current_use_propane', propaneData?.currentUse || '')
    options.append('bottle_number_propane', propaneData?.bottleNumber || '')
    options.append('bottle_size_propane', propaneData?.bottleSize || '')
    options.append('delivery_frequency_propane', propaneData?.deliveryFrequency || '')
    options.append('installation_age_propane', propaneData?.installationAge || '')
    options.append('project_deadline_propane', propaneData?.projectDeadline || '')
    options.append('tank_access_propane', propaneData?.tankAccess || '')
    options.append('tank_type_propane', propaneData?.tankType || '')
    options.append('garden_area_propane', propaneData?.gardenArea || '')
    options.append('filling_propane', propaneData?.filling?.toString() || '')
  }

  if (contractData.bacVoucher) {
    options.append('bac_voucher', '1')
  }

  if (contactPreferences.createEkomiInteraction) {
    options.append('create_ekomi_interaction', '1')
  }

  options.append('whatsapp_interaction', contactPreferences.whatsappInteraction ? '1' : '0')

  if (mainAddressData.providedByGas) {
    options.append('conso_provided_by_gas', parseInt(mainAddressData.providedByGas) === 1 ? '1' : '0')
  }

  return options
}
